module.exports = __webpack_public_path__ + "img/ita.16fa8ea8.svg";